import { Box, Button, Flex, Grid, Input } from '@chakra-ui/react';
import { InputField } from 'src/components/common/inputs/InputField/inputField';
import { FieldArrayRenderProps, useFormikContext } from 'formik';
import { placeholderUrl } from 'src/config';
import { AddScreenshotIcon } from 'src/utils/icons/addScreenshot';
import { DeleteScreenshotIcon } from 'src/utils/icons/deleteScreenshot';
import { useEffect, useMemo, useState } from 'react';
import { Color } from 'src/theme/color';
import { List, arrayMove } from 'react-movable';
import { useTranslation } from 'react-i18next';

const SCREENSHOT_FORMIK_HELPER_NAME = 'screenshotInput';

export const AddScreenshots = ({ name }: { name: string }) => {
	const { setFieldValue, values } = useFormikContext();
	const [screenshots, setScreenshots] = useState<string[]>([]);

	const addScreenshot = (value: string) => {
		if (!screenshots.includes(value)) {
			setScreenshots(state => state.concat([value]));
		}
	};

	const deleteScreenshot = (value: string) => {
		if (screenshots.includes(value)) {
			setScreenshots(state => state.filter(state => state != value));
		}
	};

	useEffect(() => {
		console.log(screenshots);
		setFieldValue(name, screenshots);
	}, [screenshots, values]);

	const acceptActive = useMemo(() => {
		return (values as any)[SCREENSHOT_FORMIK_HELPER_NAME];
	}, [(values as any)[SCREENSHOT_FORMIK_HELPER_NAME]]);

	const acceptField = () => {
		addScreenshot((values as any)[SCREENSHOT_FORMIK_HELPER_NAME]);
		setFieldValue(SCREENSHOT_FORMIK_HELPER_NAME, '');
	};

	const { t } = useTranslation();

	return (
		<Box
			mb="0px"
			w="100%"
			position="relative"
		>
			<Grid
				templateColumns="1fr auto"
				gap="16px"
				maxW="100%"
				alignItems="flex-end"
			>
				<InputField
					name={SCREENSHOT_FORMIK_HELPER_NAME}
					label={t('form.headers.screenshots')}
					leftText="URL"
					placeholder={placeholderUrl('screenshot.png')}
				/>
				<Button
					mb="6px"
					onClick={acceptField}
					fontSize="30px"
					disabled={!acceptActive}
				>
					+
				</Button>
			</Grid>

			<Flex
				position="relative"
				h="60px"
				mt="10px"
				overflow="hidden"
				maxW="100%"
			>
				<Flex overflowX="auto">
					<Flex
						h="60px"
						align="baseline"
						position="absolute"
						left="0"
						top="0"
						flexBasis="0"
						flexGrow="1"
						overflowX="scroll"
						gap="10px"
						maxW="100%"
					>
						{screenshots.map(value => {
							return (
								<Flex
									flexShrink="0"
									pos="relative"
									h="60px"
									justifySelf="flex-start"
									w={(60 * 16) / 9}
									bgImage={value}
									bgPosition="center"
									bgSize="cover"
									bgColor={Color.GRAY_3}
									borderRadius="4px"
									alignItems="center"
									key={value}
								>
									<Grid
										templateColumns="1fr 2fr 1fr"
										gridGap="15px"
										opacity="0"
										cursor="pointer"
										_hover={{ opacity: '0.7' }}
										bg={'rgb(255,255,255,0.7)'}
										w="100%"
										h="100%"
										pos="relative"
									>
										<Box
											bg="white"
											opacity="0.7"
											_hover={{ opacity: 0.9 }}
										></Box>
										<Box
											bg="white"
											opacity="0.7"
											onClick={() => deleteScreenshot(value)}
											_hover={{ opacity: 0.9 }}
										></Box>
										<Box
											bg="white"
											opacity="0.7"
											_hover={{ opacity: 0.9 }}
										></Box>
									</Grid>
								</Flex>
							);
						})}
					</Flex>
				</Flex>
			</Flex>

			<Grid />
		</Box>
	);
};
